import React from "react";

export function formatPercentage(value: number): string | null {
  if (value == null) {
    return null;
  }
  return (value / 100).toLocaleString("en-US", {
    style: "percent",
    maximumFractionDigits: 10,
  });
}

export function handleNumericField(evt: React.KeyboardEvent<HTMLDivElement>) {
  if (evt.key < "0" || evt.key > "9") {
    if (
      evt.key !== "Backspace" &&
      evt.key !== "." &&
      evt.key !== "Delete" &&
      evt.key !== "End" &&
      evt.key !== "Insert" &&
      evt.key !== "Home" &&
      evt.key !== "Tab" &&
      evt.key !== "ArrowUp" &&
      evt.key !== "ArrowDown" &&
      evt.key !== "ArrowLeft" &&
      evt.key !== "ArrowRight"
    )
      evt.preventDefault();
  }
}

export function handleIntegerField(evt: React.KeyboardEvent<HTMLDivElement>) {
  if (evt.key < "0" || evt.key > "9") {
    if (
      evt.key !== "Backspace" &&
      evt.key !== "Delete" &&
      evt.key !== "End" &&
      evt.key !== "Insert" &&
      evt.key !== "Home" &&
      evt.key !== "Tab" &&
      evt.key !== "ArrowUp" &&
      evt.key !== "ArrowDown" &&
      evt.key !== "ArrowLeft" &&
      evt.key !== "ArrowRight"
    )
      evt.preventDefault();
  }
}
